import './Home.css'
const CoursesInfo = {
    'Registration': [
        {
            'name': "Youtube 好學者會員",
            'token': '395_cpp_oop_basics'
        }
    ],
    'CppBasics': [
        /*
        {
            title: "C++ 基礎程式設計",
            hours: "15 小時以上"
        },
        */
        {
            title: "C++ 進階程式設計",
            date: ["2026 / 12 / 09"],
            url: "https://train.csie.ntu.edu.tw/school/courses/course.php?id=6373",
            enrolling: true,
            status: "招生中",
            hours: "約 18 小時 / 179 部影片"
        },
        {
            title: "C++ 專案開發基礎實戰",
            hours: "約 7 小時 / 106 部影片"
        },
        {
            title: "C++ 演算法與程式解題入門",
            date: ["2026 / 12 / 09"],
            url: "https://train.csie.ntu.edu.tw/school/courses/course.php?id=6374",
            enrolling: true,
            status: "招生中",
            hours: "約 11 小時 / 128 部影片"
        },
        {
            title: "C++ 資料結構與泛型程式設計基礎",
            timeslot: "線上課程",
            hours: "約 9 小時 / 91 部影片"
        },
        {
            title: "C++ 多執行緒與並行程式設計基礎",
            hours: "約 8 小時 / 73 部影片"
        },
        {
            title: "C++ 物件導向與設計模式基礎",
            date: ["2026 / 12 / 09"],
            url: "https://train.csie.ntu.edu.tw/school/courses/course.php?id=6372",
            enrolling: true,
            status: "招生中",
            hours: "約 5 小時 / 51 部影片"
        }
    ],
    'MasteringCodingAgents': [
        // 系列四門課，由內到外：原理（B）→ 進階（C）→ 審查（D）→ 實戰（A）。
        // 舊課名還在招生的梯次先掛在對應的新課上：應用實戰 → 實戰；從原理到掌控自動化開發（6364）→ 原理。
        // 6442 已由行政原地換成新課名「原理」（12/19–12/20 六日班）；6364 開課後（11/28）原理的連結換成 6442。
        // 首頁各班別的上課日期改讀 courseClasses.json（scripts/sync-course-classes.mjs 從 csie-train 課表產生）；
        // 這裡的 date／url／enrolling 不再顯示，只留給 csie-monitor 每天對帳 train 站。
        {
            title: "駕馭程式代理人實戰：用 AI 開發軟體",
            timeslot: "週末兩天課程／週二、週三夜間班",
            date: ["2026 / 11 / 14"],
            hours: "共 10 小時",
            enrolling: true,
            status: "確定開課",
            url: "https://train.csie.ntu.edu.tw/school/courses/course.php?id=6397"
        },
        {
            title: "駕馭程式代理人原理：從零打造 AI 代理",
            timeslot: "週末兩天課程／週二、週三夜間班",
            date: ["2026 / 11 / 28"],
            hours: "共 10 小時",
            enrolling: true,
            status: "確定開課",
            url: "https://train.csie.ntu.edu.tw/school/courses/course.php?id=6364"
        },
        {
            title: "駕馭程式代理人進階：擁有專屬的 AI 代理",
            timeslot: "週末兩天課程／週二、週三夜間班",
            date: ["2027 / 01 / 10"],
            hours: "共 10 小時"
        },
        {
            title: "駕馭程式代理人審查：為 AI 寫的軟體把關",
            timeslot: "週末兩天課程／週二、週三夜間班",
            date: ["2027 / 01 / 05"],
            hours: "共 10 小時"
        }
    ],
    // 《工程師核心素養》（Core Competencies for Engineers）：AI 很強，但工程師仍該懂的基礎。
    // 2026-10-31 由「深入掌握程式語言」改名，只留 Python 資料結構與演算法，之後擴充成軟體工程師的基礎功課程。
    'CoreCompetencies': [
        {
            title: "Python 資料結構與演算法",
            timeslot: "線上課程"
        }
    ]
}

export default CoursesInfo
